











































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'

@Component
export default class ExternalLinkBox extends Vue {
  @Prop() private data!: any

  private displaySelectedVariety (variety: any) {
    if (variety.is_all_varieties) {
      return 'すべて'
    }
    if (variety.variety_options.length === 0) {
      return '-'
    }
    const varietyNames = []
    for (const data of variety.variety_options) {
      varietyNames.push(data.variety_name)
    }
    return varietyNames.join(',')
  }

  private displaySelectedDistrict (district: any) {
    if (district.is_all_districts) {
      return 'すべて'
    }
    if (district.district_options.length === 0) {
      return '-'
    }
    const districtNames = []
    for (const data of district.district_options) {
      districtNames.push(data.district_name)
    }
    return districtNames.join(',')
  }

  private isNotData (data: any) {
    return data.length === 0
  }

  private async getExternalLinkFile (id: number, content_name: string) {
    const objectURL = await GetExternalLinkFileApi.getExternalLinkFile(id)
    if (typeof objectURL === 'string') {
      let link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectURL
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectURL)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }

  private shapingDateToString (day: string) {
    const data = new Date(day)
    const year = data.getFullYear()
    const month = '0' + (data.getMonth() + 1)
    const date = '0' + data.getDate()
    return year + '年' + month.slice(-2) + '月' + date.slice(-2) + '日'
  }
}

